<template>
  <InnerCardInfo
    v-if="cardData"
    :label="
      localStorage.translations.pages['setting-personal_area'].sections['karta-bezopasnosti-truda']
    "
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya'],
        value: dateEndFormatted || '-',
      },
    ]"
    :images="cardData.image"
    need-image-domain
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'SafetyCardPdf',
  props: {
    safety_card: Object,
    editReady: Boolean,
  },
  components: { InnerCardInfo },
  data: () => ({
    cardData: null,
    dateEnd: null,
    dateEndFormatted: null,
  }),
  watch: {
    safety_card() {
      this.getData()
    },
    dateEnd(val) {
      this.dateEndFormatted = this.formatDate(this.dateEnd)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.safety_card) {
        this.cardData = JSON.parse(this.safety_card.data)
        this.dateEnd = this.cardData.date_end
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return (day ? day + '.' : '') + (month ? month + '.' : '') + year
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>
